import {newModalFromString} from './components/modal';

class ProfileEnrich {
    init () {
        // this.initOutsideClickHandler();
        this.initNextButton();
        this.initPrevButton();
        this.enableNextButton();
        this.initCheckboxes();
    }

    initOutsideClickHandler () {
        if ($('.page').data('action') !== 'Account-EnrichForm') {
            return;
        }
        var elementsSelector = '.cc-accountNavigation, header, .js-myInformation-chips, .js-menu-tab, .cc-accountBreadcrumbs__link, .cc-mainHeader-item, .js-mainHeader-search';
        var _self = this;

        $(elementsSelector).on('click', function (e) {
            var clickedElement = $(e.target);
            var $isOutsideClicked = $('#isOutsideClicked');
            if ($isOutsideClicked.val() === 'false') {
                e.preventDefault();
                $isOutsideClicked.val('true');
                _self.openExitModal(clickedElement);
            }
        });
    }

    initNextButton () {
        var _self = this;
        $('input').on('change', function (e) {
            _self.enableNextButton();
        });
        $('.js-proceed-next-step').on('click', function (e) {
            var currentStep = $(e.currentTarget).attr('data-step');
            var formData = {};
            var checkboxesChecked;
            if ($('.step-container.' + currentStep + ' .js-step-section:not(.inactive)').length > 0) {
                checkboxesChecked = $('.step-container.' + currentStep + ' .js-step-section:not(.inactive) input[type="checkbox"]:checked');
            } else {
                checkboxesChecked = $('.step-container.' + currentStep + ' input[type="checkbox"]:checked');
            }
            var preferences = [];
            var analyticsData = [];
            var categories = [];
            var subcategories = [];

            checkboxesChecked.each(function () {
                preferences.push($(this).val());
                if ($(this).attr('data-analytics')) {
                    analyticsData.push($(this).attr('data-analytics').toLowerCase());
                };
                if ($(this).attr('data-analytics-category')) {
                    categories.push($(this).attr('data-analytics-category').toLowerCase());
                };
                if ($(this).attr('data-analytics-subcategory')) {
                    subcategories.push($(this).attr('data-analytics-subcategory').toLowerCase());
                };
            });
            formData.preferences = preferences.join(',');
            formData.isLastStep = _self.isLastStep() || _self.isFinalEditStep();
            _self.callSavePreference(formData);
            _self.applyDependences(preferences);

            $('body').trigger('analytics:profileEnrich', {
                step: currentStep,
                preferences: analyticsData,
                categories: categories,
                subcategories: subcategories});
            window.scrollTo(0, 0);
        });
    }

    enableNextButton () {
        var allSectionsValid = true;
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        var sections = $('.step-container.' + currentStep + ' .js-step-section:not(.inactive)');

        if (sections.length > 0) {
            if (currentStep === 'step_4') {
                sections.each(function () {
                    var sectionChecked = $(this).find('input:not(.js-child-accordion):checked').length;
                    if (sectionChecked === 0) {
                        allSectionsValid = false;
                        return false; // Exit the loop if any section is invalid
                    }
                });
            }

            var parentSections = $('.step-container.' + currentStep + ' .js-step-section:not(.inactive) .js-has-subitem .js-select-accordion:checked');
            parentSections.each(function () {
                if ($(this).closest('.js-has-subitem').find('.js-child-accordion:checked').length === 0) {
                    allSectionsValid = false;
                    return false;
                }
            });

            if (allSectionsValid !== false) {
                if ($('.step-container.' + currentStep + ' .js-step-section:not(.inactive)').find('input:not(.js-child-accordion):checked').length > 0) {
                    allSectionsValid = true;
                } else {
                    sections.each(function () {
                        var sectionChecked = $(this).find('input:not(.js-child-accordion):checked').length;
                        if (sectionChecked === 0) {
                            allSectionsValid = false;
                            return false; // Exit the loop if any section is invalid
                        }
                    });
                }
            }
        } else {
            var checked = $('.step-container.' + currentStep + ' input:checked').length;
            if (checked === 0) {
                allSectionsValid = false;
            }
        }

        if (allSectionsValid) {
            $('.js-proceed-next-step').prop('disabled', false);
            $('.js-proceed-last-step').prop('disabled', false);
        } else {
            $('.js-proceed-next-step').prop('disabled', true);
            $('.js-proceed-last-step').prop('disabled', true);
        }
    }

    initPrevButton () {
        var _self = this;
        $('.js-proceed-prev-step').on('click', function (e) {
            _self.moveToPrevStep();
            window.scrollTo(0, 0);
        });
    }

    callSavePreference (formData) {
        var _self = this;
        var url = $('#savePreferenceUrl').val();
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                $.spinner().stop();
                if (data.success) {
                    _self.moveToNextStep();
                } else {

                }
            },
            error: function (data) {
                $.spinner().stop();
            }
        });
    }

    moveToNextStep () {
        var lastStep = $('#lastStep').val();
        var mainPageUrl = $('#mainPageUrl').val();
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex + 1;
        var nextStep = 'step_' + nextStepIndex;
        var isFinalEditStep = this.isFinalEditStep();
        if (currentStep === lastStep || isFinalEditStep) {
            window.location.href = mainPageUrl;
        } else {
            $mappingContainer.attr('data-step', nextStep);
        }
        this.enableNextButton();
    }

    isFinalEditStep () {
        var isProfileEnriched = $('#isProfileEnriched').val() === 'true';
        if (!isProfileEnriched) return false;
        var currentStep = this.getCurrentStep();
        return currentStep !== 'step_1';
    }

    getCurrentStep () {
        return $('.mapping-container').attr('data-step');
    }

    getCurrentStepDependencies () {
        var currentStep = this.getCurrentStep();
        return $('.step-container.' + currentStep).attr('data-dependencies');
    }

    applyDependences (preferences) {
        var dependencies = this.getCurrentStepDependencies();
        var currentStep = this.getCurrentStep();
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex + 1;
        var nextStep = 'step_' + nextStepIndex;
        if (dependencies === undefined || dependencies === '') {
            return;
        }
        var $dependentElements = $('.step-container.' + nextStep + ' .js-step-section');
        $dependentElements.toArray().forEach(element => {
            var dependenciesCodes = $(element).attr('data-dependencies-code');
            if (preferences.indexOf(dependenciesCodes) === -1) {
                $(element).addClass('inactive');
            } else {
                $(element).removeClass('inactive');
            }
        });
    }

    moveToPrevStep () {
        var $mappingContainer = $('.mapping-container');
        var currentStep = this.getCurrentStep();
        var currentStepIndex = parseInt(currentStep.split('_')[1]);
        var nextStepIndex = currentStepIndex - 1;
        var nextStep = 'step_' + nextStepIndex;
        $mappingContainer.attr('data-step', nextStep);
        this.enableNextButton();
    }

    initCheckboxes () {
        var checkboxes = $('.js-select-accordion');
        checkboxes.toArray().forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    $(checkbox).parents('.cc-final-sub-main-category-wrp').addClass('cc-active');
                } else {
                    $(checkbox).parents('.cc-final-sub-main-category-wrp').removeClass('cc-active');
                }
            });
        });
    }

    openExitModal (clickedElement) {
        const htmlContent = $('#confirmExitModal').clone().html();
        var modal;
        var $isOutsideClicked = $('#isOutsideClicked');
        const onClose = () => {
            $isOutsideClicked.val('false');
        };
        modal = newModalFromString(htmlContent, false, [], null, onClose);
        modal.open();
        $(modal.modalBox)
            .find('.close-button-info')
            .on('click', function () {
                modal.close();
            });
        $(modal.modalBox).on('click', '.js-proceed-exit', function (e) {
            e.preventDefault();
            $isOutsideClicked.val('true');
            // clickedElement.trigger('click');
            var loyaltyPageUrl = $('#loyaltyPageUrl').val();
            window.location.href = loyaltyPageUrl;
        });

        $(modal.modalBox).on('click', '.js-exit', function (e) {
            e.preventDefault();
            modal.close();
            modal.destroy();
        });
    }

    isLastStep () {
        var lastStep = $('#lastStep').val();
        var $mappingContainer = $('.mapping-container');
        var currentStep = $mappingContainer.attr('data-step');
        return currentStep === lastStep;
    }
}

const profileEnrich = new ProfileEnrich();
export default profileEnrich;
